import { useEffectOnce } from 'react-use';

type MatomoTagManagerAnalyticsProps = Readonly<{
   containerUrl: string;
}>;

export const MatomoTagManagerAnalytics = (props: MatomoTagManagerAnalyticsProps): null => {
   useEffectOnce(() => {
      const scriptElement = document.createElement('script');
      scriptElement.type = 'text/javascript';
      scriptElement.innerHTML = `
<!-- Matomo Tag Manager -->
var _mtm = window._mtm = window._mtm || [];
_mtm.push({'mtm.startTime': (new Date().getTime()), 'event': 'mtm.Start'});
(function() {
  var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
  g.async=true; g.src='${props.containerUrl}'; s.parentNode.insertBefore(g,s);
})();
<!-- End Matomo Tag Manager -->
      `;

      document.head.appendChild(scriptElement);

      return () => {
         document.head.removeChild(scriptElement);
      };
   });

   return null;
};
